export default {
    removeSocialMedia: {
        text: 'Le réseau {{0}} a bien été supprimé',
    },
    addSocialMedia: {
        text: 'Le réseau {{0}} a bien été ajouté',
    },
    instaConnect: 'Le réseau Instagram a été ajouté',
};
